<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.dataMain.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-container style="border: 1px solid #eee">
            <el-aside :style="{ width: '200px', 'background-color': '#fff', height: leftHeight }">
                <el-input :placeholder="$t('pages.dataMain.filterPh')" v-model="filterText"></el-input>
                <div style="width: 100%; height: 15px; background-color: #f0f0f0"></div>
                <div :style="{ height: leftTreeHeight, 'overflow-y': 'auto' }">
                    <el-tree class="filter-tree" :data="LeftTrees" :props="defaultProps" node-key="id" default-expand-all :filter-node-method="filterNode" ref="tree" style="height: 50px" @node-click="handleNodeClick" highlight-current></el-tree>
                </div>
            </el-aside>
            <el-main>
                <div>
                    <div class="handle-headleft">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.dataMain.add')}}</el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="delSel">{{$t('pages.dataMain.delete')}}</el-button>
                        <el-button type="primary" icon="el-icon-edit-outline" @click="editSel">{{$t('pages.dataMain.edit')}}</el-button>
                        <el-button type="success" icon="el-icon-collection-tag" @click="datadictype">{{$t('pages.dataMain.dictType')}}</el-button>
                        <el-button icon="el-icon-refresh" @click="IniData"></el-button>
                    </div>
                    <div class="handle-headright">
                        <el-input v-model="query.Field1" @blur="getData()" class="handle-search mr10" :placeholder="$t('pages.dataMain.searchPh')"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.dataMain.search')}}</el-button>
                    </div>
                </div>
                <el-table :data="datamains" border class="table" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column type="index" width="50" :label="$t('pages.dataMain.index')"></el-table-column>
                    <el-table-column prop="name" :label="$t('pages.dataMain.itemName')" width="200"></el-table-column>
                    <el-table-column prop="value" :label="$t('pages.dataMain.itemValue')" width="200"></el-table-column>
                    <el-table-column prop="iorder" :label="$t('pages.dataMain.order')" width="80"></el-table-column>
                    <el-table-column :label="$t('pages.dataMain.enabled')" width="80">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.enabled" :active-value="1" :inactive-value="2" @change="changeSwitch(scope.row)" />
                        </template>
                    </el-table-column>
                    <!-- active-color="#02538C" inactive-color="#B9B9B9" -->
                    <!-- <el-table-column prop="enabled" label="有效" width="80"></el-table-column> -->
                    <el-table-column prop="remark" :label="$t('pages.dataMain.remark')"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
                </div>
            </el-main>
        </el-container>
        <!-- 编辑弹出框 -->
        <el-dialog :title="$t('pages.dataMain.dictType')" :visible.sync="DicTypeVisible" width="60%" :close-on-click-modal="false">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addTree">{{$t('pages.dataMain.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delTree">{{$t('pages.dataMain.delete')}}</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" @click="editTree">{{$t('pages.dataMain.edit')}}</el-button>
                    <el-button icon="el-icon-refresh" @click="getDataTree"></el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query1.Field1" class="handle-search mr10" :placeholder="$t('pages.dataMain.searchNameCodePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getDataTree">{{$t('pages.dataMain.search')}}</el-button>
                </div>
            </div>
            <el-table :data="DataTrees" border class="table" ref="multipleTable" header-cell-class-name="table-header" row-key="id" @selection-change="handleSelectionChange" @row-dblclick="dbItemSelected" default-expand-all :tree-props="{ children: 'children' }">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.dataMain.index')"></el-table-column>
                <el-table-column sortable prop="value" width="200" :label="$t('pages.dataMain.name')"></el-table-column>
                <el-table-column prop="code" :label="$t('pages.dataMain.code')" width="200"></el-table-column>
                <el-table-column prop="iorder" width="70" :label="$t('pages.dataMain.order')"></el-table-column>
                <!-- <el-table-column prop="enabled" width="70" label="有效"></el-table-column> -->
                <el-table-column :label="$t('pages.dataMain.enabled')" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabled" :active-value="1" :inactive-value="2" @change="changeTreeSwitch(scope.row)" />
                    </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('pages.dataMain.remark')"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="DicTypeVisible = false">{{$t('pages.dataMain.close')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="headTitleItem" :visible.sync="editVisibleItem" width="25%" :close-on-click-modal="false">
            <el-form ref="DataMainItem" :rules="rules" :model="DataMainItem" label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.dictType')" prop="dictype">
                            <el-input v-model="DataMainItem.dictype" class="size-full" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.itemName')" prop="name">
                            <el-input v-model="DataMainItem.name" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.itemValue')" prop="value">
                            <el-input v-model="DataMainItem.value" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.order')" prop="iorder">
                            <el-input-number v-model="DataMainItem.iorder" :min="0" class="size-full"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.enabled')" prop="enabled">
                            <el-switch v-model="DataMainItem.enabled" :active-value="1" :inactive-value="2" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.dataMain.remark')" prop="remark">
                            <el-input type="textarea" v-model="DataMainItem.remark" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisibleItem = false">{{$t('pages.dataMain.cancel')}}</el-button>
                <el-button type="primary" @click="saveEditItem('DataMainItem')">{{$t('pages.dataMain.confirm')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="headTitleTree" :visible.sync="editVisibleTree" width="25%" :close-on-click-modal="false">
            <div class="el-dialog-div">
                <el-form ref="DataMainTree" :rules="rules" :model="DataMainTree" label-width="90px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.parent')" prop="treeid">
                                <el-popover placement="bottom-start" v-model="treeFlag" class="orgTree" width="300" trigger="click">
                                    <el-tree :data="DataTrees" :props="defaultProps" :expand-on-click-node="false" node-key="id" class="size-full" default-expand-all @node-click="handleNodeClickDep"></el-tree>
                                    <el-input slot="reference" ref="input" v-model="DataMainTree.pname" clearable :readonly="true" class="size-full" suffix-icon="el-icon-arrow-down" :placeholder="$t('pages.dataMain.selectPh')"></el-input>
                                </el-popover>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.name')" prop="value">
                                <el-input v-model="DataMainTree.value" class="size-full"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.code')" prop="code">
                                <el-input v-model="DataMainTree.code" class="size-full"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.order')" prop="iorder">
                                <el-input-number v-model="DataMainTree.iorder" :min="0" class="size-full"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.enabled')" prop="enabled">
                                <el-switch v-model="DataMainTree.enabled" :active-value="1" :inactive-value="2" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pages.dataMain.remark')" prop="remark">
                                <el-input type="textarea" v-model="DataMainTree.remark" class="size-full"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisibleTree = false">{{$t('pages.dataMain.cancel')}}</el-button>
                <el-button type="primary" @click="saveEditTree('DataMainTree')">{{$t('pages.dataMain.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { dateFormat, SortField, toTree } from '../../utils/helper';
export default {
    name: 'DataMain',
    data: function () {
        return {
            rules: {
                name: [{ required: true, message: this.$t('pages.dataMain.valid.nameRequired'), trigger: 'blur' }],
                value: [{ required: true, message: this.$t('pages.dataMain.valid.valueRequired'), trigger: 'blur' }]
            },
            datamains: [],
            multipleSelection: [],
            query: {
                Field1: '',
                Field2: '',
                Field3: '',
                Field4: ''
            },
            query1: {
                Field1: '',
                Field2: '',
                Field3: ''
            },
            pageCount: 1,
            filterText: '',
            leftHeight: '',
            leftTreeHeight: '',
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            DicTypeVisible: false,
            DataTrees: [],
            DataList: [],
            LeftTrees: [],
            delList: [],
            headTitleItem: '',
            isaddItem: true,
            DataMainItem: {},
            editVisibleItem: false,
            DataMainTree: {},
            headTitleTree: '',
            editVisibleTree: false,
            isaddTree: true,
            treeFlag: true
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    created() {
        this.getLeftTree();
    },
    mounted: function () {
        this.setCJHeight();
    },
    methods: {
        saveEditItem() {
            this.$refs['DataMainItem'].validate((valid) => {
                if (valid) {
                    if (this.isaddItem) {
                        this.$zybhttp
                            .post('DataCode/CodeMainAdd', this.DataMainItem)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dataMain.addSuccess'));
                                    this.getData();
                                    this.editVisibleItem = false;
                                    this.DataMainItem = {};
                                } else {
                                    this.$notify.error(this.$t('pages.dataMain.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dataMain.addError')));
                    } else {
                        this.$zybhttp
                            .post('DataCode/CodeMainUpdate', this.DataMainItem)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dataMain.updateSuccess'));
                                    this.getData();
                                    this.editVisibleItem = false;
                                } else {
                                    this.$notify.error(this.$t('pages.dataMain.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dataMain.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveEditTree() {
            this.$refs['DataMainTree'].validate((valid) => {
                if (valid) {
                    this.DataMainTree.pid = this.DataMainTree.pid == undefined ? '0' : this.DataMainTree.pid;
                    if (this.isaddTree) {
                        this.$zybhttp
                            .post('CodeTree/CodeTreeAdd', this.DataMainTree)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dataMain.addSuccess'));
                                    this.getDataTree();
                                    this.editVisibleTree = false;
                                    this.DataMainTree = {};
                                } else {
                                    this.$notify.error(this.$t('pages.dataMain.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dataMain.addError')));
                    } else {
                        this.$zybhttp
                            .post('CodeTree/CodeTreeUpdate', this.DataMainTree)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dataMain.updateSuccess'));
                                    this.getDataTree();
                                    this.editVisibleTree = false;
                                } else {
                                    this.$notify.error(this.$t('pages.dataMain.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dataMain.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        changeSwitch(item) {
            this.$zybhttp
                .post('DataCode/CodeMainUpdate', item)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.dataMain.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.dataMain.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dataMain.updateError')));
        },
        changeTreeSwitch(item) {
            this.$zybhttp
                .post('CodeTree/CodeTreeUpdate', item)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.dataMain.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.dataMain.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dataMain.updateError')));
        },
        datadictype() {
            this.getDataTree();
            this.DicTypeVisible = true;
        },
        handleNodeClick(data, node, self) {
            this.query.Field2 = data.code;
            this.query.Field3 = data.label;
            this.query.Field4 = data.pid;
            if (data.pid != '0') {
                this.getData();
            }

            let key = this.$refs.tree.getCurrentKey();
            let returnData = { data: data, key: key };
            //获取数据id,后台通过ID获取类型与数据
            this.$emit('getNodeId', returnData);
        },
        handleNodeClickDep: function (val) {
            this.DataMainTree.pname = val.label;
            this.treeFlag = false;
            this.DataMainTree.pid = val.id;
        },
        IniData() {
            this.query.Field1 = '';
            this.query.Field2 = '';
            this.query1.Field1 = '';
            this.query1.Field2 = '';
            this.DataMainItem = {};
            this.DataMainTree = {};
            this.getData();
            this.getLeftTree();
        },
        getData() {
            this.$zybhttp
                .post('DataCode/GetStructList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.datamains = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dataMain.fetchError')));
        },
        getDataTree() {
            this.$zybhttp
                .post('CodeTree/GetList', this.query1)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var newdata = res.data.list;
                        newdata.map((x) => (x['label'] = x.value));
                        this.DataList = JSON.parse(JSON.stringify(newdata));
                        this.DataTrees = toTree(newdata);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dataMain.fetchError')));
        },
        getLeftTree() {
            this.$zybhttp
                .post('CodeTree/GetList', { Field2: '1' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var newdata = res.data.list;
                        newdata.map((x) => (x['label'] = x.value));
                        this.LeftTrees = toTree(newdata);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dataMain.fetchError')));
        },
        indexMethod(index) {
            return index + 1;
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        dbSelected(row) {
            this.DataMainItem = row;
            this.DataMainItem.id = row.id;
            this.editVisibleItem = true;
            this.isaddItem = false;
            this.headTitleItem = this.$t('pages.dataMain.editItemTitle');
            this.DataMainItem.dictype = this.query.Field3;
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        setCJHeight() {
            this.$nextTick(() => {
                // 页面渲染完成后的回调
                var headerHeight = document.getElementsByClassName('content')[0].offsetHeight;
                this.leftHeight = headerHeight * 0.93 + 'px';
                this.leftTreeHeight = headerHeight * 0.85 + 'px';
            });
        },
        dbItemSelected(row) {
            this.DataMainTree = row;
            this.DataMainTree.id = row.id;
            this.editVisibleTree = true;
            this.isaddTree = false;
            this.headTitleTree = '修改分类';
            var pArr = JSON.parse(JSON.stringify(this.DataList));
            var pname = pArr.filter((x) => x.id == row.pid)[0].value;
            this.DataMainTree.pname = pname;
        },
        handleAdd() {
            if (this.query.Field2 == '') {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectLeftCategory'));
                return;
            }
            if (this.query.Field4 == '0') {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectLeafOnly'));
                return;
            }
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.DataMainItem = {};
            this.isaddItem = true;
            let date = new Date();
            // this.DataMainItem.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.DataMainItem.createUserId = userinfo.loginId;
            this.DataMainItem.modifyUserId = userinfo.loginId;
            this.editVisibleItem = true;
            this.headTitleItem = this.$t('pages.dataMain.addItemTitle');
            this.DataMainItem.code = this.query.Field2;
            this.DataMainItem.dictype = this.query.Field3;
            this.DataMainItem.enabled = 1;
        },
        delSel() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ',';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.dataMain.confirmDelete'), this.$t('pages.dataMain.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Account/UserDel?ids=1')
                        .get('DataCode/CodeMainDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.dataMain.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.dataMain.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.dataMain.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        editSel() {
            const length = this.multipleSelection.length;
            if (length == 0) {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectOneToEdit'));
                return;
            }
            if (length > 1) {
            this.$notify.warning(this.$t('pages.dataMain.warn.onlyOneToEdit'));
                return;
            }
            var row = this.multipleSelection[0];
            this.DataMainItem = row;
            this.DataMainItem.id = row.id;
            this.editVisibleItem = true;
            this.isaddItem = false;
            this.headTitleItem = this.$t('pages.dataMain.editItemTitle');
            this.DataMainItem.dictype = this.query.Field3;
        },
        addTree() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.DataMainTree = {};
            this.isaddTree = true;
            let date = new Date();
            // this.DataMainItem.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.DataMainTree.createUserId = userinfo.loginId;
            this.DataMainTree.modifyUserId = userinfo.loginId;
            this.editVisibleTree = true;
            this.headTitleTree = this.$t('pages.dataMain.addTypeTitle');
            this.DataMainTree.enabled = 1;
        },
        editTree() {
            const length = this.multipleSelection.length;
            if (length == 0) {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectOneToEdit'));
                return;
            }
            if (length > 1) {
            this.$notify.warning(this.$t('pages.dataMain.warn.onlyOneToEdit'));
                return;
            }
            var row = this.multipleSelection[0];
            this.DataMainTree = row;
            this.DataMainTree.id = row.id;
            this.editVisibleTree = true;
            this.isaddTree = false;
            var pArr = JSON.parse(JSON.stringify(this.DataList));
            var pname = pArr.filter((x) => x.id == row.pid)[0].value;
            this.DataMainTree.pname = pname;
            this.headTitleTree = this.$t('pages.dataMain.editTypeTitle');
        },
        delTree() {
            const delArr = this.multipleSelection;
            let flagChild = delArr.filter((x) => x.IsChildren == true && Object.getOwnPropertyNames(x).indexOf('children') > 0);
            if (flagChild.length > 0) {
                this.$notify.warning(this.$t('pages.dataMain.warn.hasChildren'));
                return;
            }
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].value + ',';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
            this.$notify.warning(this.$t('pages.dataMain.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.dataMain.confirmDelete'), this.$t('pages.dataMain.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Account/UserDel?ids=1')
                        .get('CodeTree/CodeTreeDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.dataMain.deleteSuccess', { names: str }));
                                this.getDataTree();
                            } else {
                                this.$notify.error(this.$t('pages.dataMain.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.dataMain.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.handle-search {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

/* .el-button + .el-button {
    margin-left: 2px;
} */

.el-button--small,
.el-button--small.is-round {
    padding: 9px 8px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}

.el-main {
    color: #333;
    text-align: center;
    padding: 0px 0px 0px 15px;
}
</style>
<style>
.el-dialog__body {
    height: 50vh;
    overflow: auto;
}
.el-tree-node.is-current > .el-tree-node__content {
    background-color: #dfe0e0 !important;
}
</style>
